import React from 'react';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router-dom';

import {
  Container,
  Background,
  Content,
  Wrapper,
  BrandContent,
  BrandBadge,
  BrandTitle,
  BrandDescription,
  FeatureList,
  FeatureItem,
  ProductPreview,
  PreviewHeader,
  PreviewRows,
  PreviewRow,
} from './styles';

function AuthLoginLayout({ children }) {
  const { pathname } = useLocation();

  const personalizacao = pathname.replace('/login/', '');

  return (
    <Container>
      <Background personalizacao={personalizacao} />

      <Content>
        <Wrapper>{children}</Wrapper>

        <BrandContent>
          <BrandBadge>Plataforma ASSISTE</BrandBadge>

          <BrandTitle>Catálogo Digital Interativo</BrandTitle>

          <BrandDescription>
            Centralize consulta visual de peças, rastreabilidade de materiais e
            governança operacional em uma plataforma segura da ASSISTE.
          </BrandDescription>

          <FeatureList>
            <FeatureItem>
              <strong>Consulta técnica inteligente</strong>
              <span>Catálogos organizados por sistemas, páginas e itens.</span>
            </FeatureItem>

            <FeatureItem>
              <strong>Integração com ERP</strong>
              <span>
                Vínculo entre Part Number, fabricante e código interno de
                material.
              </span>
            </FeatureItem>

            <FeatureItem>
              <strong>Operação segura</strong>
              <span>
                Acesso controlado para equipes, manutenção e fornecedores.
              </span>
            </FeatureItem>
          </FeatureList>

          {/* <ProductPreview>
            <PreviewHeader>
              <span>Resumo da plataforma</span>
              <strong>CDI</strong>
            </PreviewHeader>

            <PreviewRows>
              <PreviewRow>
                <span>Catálogos técnicos</span>
                <strong>Sistemas e páginas</strong>
              </PreviewRow>

              <PreviewRow>
                <span>Materiais</span>
                <strong>Part Number e ERP</strong>
              </PreviewRow>

              <PreviewRow>
                <span>Identificação visual</span>
                <strong>SVG interativo</strong>
              </PreviewRow>
            </PreviewRows>
          </ProductPreview> */}
        </BrandContent>
      </Content>
    </Container>
  );
}

AuthLoginLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export { AuthLoginLayout };
